import {createContext} from "react";

export const DirectionContext = createContext({
    isRtl: ""
});